import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Card, Divider, InputNumber} from 'antd';
import {getProductToReorderList} from './actions';
import {bindActionCreators} from "redux";
import ResponsiveTable from "../common/ResponsiveTable";

function suggestedQuantity(record) {
  return (((record.quantitySold / record.overPeriodInDays) * record.daysToReorder) + 0.49).toFixed();
}

const productToReorderListColumns = [
  {
    title: 'Supplier',
    dataIndex: 'supplierName',
    key: 'supplierName'
  },
  {
    title: 'Product',
    dataIndex: 'productDisplay',
    key: 'productDisplay'
  },
  {
    title: 'Order Code',
    dataIndex: 'supplierOrderCode',
    key: 'orderCode'
  },
  {
    title: 'Quantity in Stock',
    dataIndex: 'quantityInStock',
    key: 'quantityInStock'
  },
  {
    title: 'Quantity Sold',
    dataIndex: 'quantitySold',
    key: 'quantitySold'
  },
  {
    title: 'Over Period',
    dataIndex: 'overPeriodInDays',
    key: 'overPeriodInDays',
    render: value => <span>{value} day(s)</span>
  },
  {
    title: 'Suggested Quantity',
    dataIndex: 'daysToReorder',
    key: 'suggestedQty',
    render: (_, record) => <span>{suggestedQuantity(record)}</span>
  },
  {
    title: 'Suggested Quantity to Order',
    dataIndex: 'daysToReorder',
    key: 'toOrder',
    render: (_, record) => <span>{suggestedQuantity(record) - record.quantityInStock}</span>
  }
];

class ProductToReorderListPage extends Component {
  state = {
    daysToReorder: 14
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this._load();
  }

  _load = () => {
    const {dispensaryId} = this.props;
    this.props.getProductToReorderList({dispensaryId, visibleOnly: true});
  };

  _transformData = (data) => {
    const {daysToReorder} = this.state;
    return data.map(x => ({...x, daysToReorder}))
      .filter(p => suggestedQuantity(p) > p.quantityInStock);
  };

  render() {
    const {daysToReorder} = this.state;
    const {productToReorderList} = this.props;
    const productsToReorder = this._transformData(productToReorderList);
    return (
      <Card title="Product To Reorder List">
        Reorder for&nbsp;
        <InputNumber value={daysToReorder} onChange={daysToReorder => this.setState({daysToReorder})} />
        &nbsp;days
        <Divider type="horizontal" />
        <ResponsiveTable
          columns={productToReorderListColumns}
          dataSource={productsToReorder}
          rowKey="productId"
          onChange={this._load}
        />
      </Card>
    );
  }
}

ProductToReorderListPage.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  productToReorderList: PropTypes.array.isRequired,
  getProductToReorderList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  productToReorderList: state.product.productToReorderList,
});

const mapDispatchToProps = dispatch => ({
  getProductToReorderList: bindActionCreators(getProductToReorderList, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductToReorderListPage);



// WEBPACK FOOTER //
// ./src/Product/ProductToReorderListPage.js